import request from './.request'

/**
 * 根据地块id，获取这个地块上种植计划的详细
 * @param {number} landId 
 * @returns 
 */
export function getPlanByLand(landId) {
  return request({
    url: `/plan/${landId}?by=land`,
    method: 'get',
  })
}

/**
 * 根据种植计划id查询其所有阶段
 * @param {number} planId 
 * @returns 
 */
export function getPhasesOfPlan(planId) {
  return request({
    url: `/plan/${planId}/phases`,
    method: 'get',
  })
}

/**
 * 根据种植计划id查询其所有专家建议
 * @param {number} planId 
 * @returns 
 */
 export function getSuggestsOfPlan(planId) {
  return request({
    url: `/plan/${planId}/suggests`,
    method: 'get',
  })
}


// WEBPACK FOOTER //
// ./src/api/plan2.js